import React from 'react';

import { Card, Col, Form, Input, Row, Select } from 'antd';
import PropTypes from 'prop-types';

import { InputMask } from '~/components';
import { formatModulo, normalizeDocument } from '~/helpers/functions';

const { Option } = Select;

function Filtro({ filtro, setFiltro }) {
  const handleKeyPress = (e, key) => {
    const { value } = e.target;
    let newValue = value;

    if (e.key === 'Enter') {
      if (key === 'cnpj') {
        newValue = normalizeDocument(newValue);
      }
      setFiltro((prev) => ({ ...prev, [key]: newValue }));
    }
  };

  const handleChange = (value, key) => {
    setFiltro((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Card>
      <Form layout="vertical" initialValues={filtro}>
        <Row gutter={16}>
          <Col xl={6} md={12} span={24}>
            <Form.Item label="Empresa" name="empresa">
              <Input onKeyPress={(e) => handleKeyPress(e, 'empresa')} />
            </Form.Item>
          </Col>

          <Col xl={3} md={12} span={24}>
            <Form.Item label="CNPJ" name="cnpj">
              <InputMask.Document onKeyPress={(e) => handleKeyPress(e, 'cnpj')} />
            </Form.Item>
          </Col>

          <Col xl={8} md={12} span={24}>
            <Form.Item label="Módulo" name="modulo">
              <Select onChange={(e) => handleChange(e, 'modulo')}>
                <Option value="">Selecionar módulo</Option>
                <Option value="eRecuperadorPisCofins">
                  {formatModulo('eRecuperadorPisCofins')}
                </Option>
                <Option value="eRecuperadorSegregadorIcms">
                  {formatModulo('eRecuperadorSegregadorIcms')}
                </Option>
                <Option value="ExclusaoIcms">{formatModulo('ExclusaoIcms')}</Option>
                <Option value="ExclusaoIssqn">{formatModulo('ExclusaoIssqn')}</Option>
                <Option value="VerbasInss">{formatModulo('VerbasInss')}</Option>
                <Option value="ContribuicoesTerceiros">
                  {formatModulo('ContribuicoesTerceiros')}
                </Option>
                <Option value="RecuperacaoCreditoTributario">
                  {formatModulo('RecuperacaoCreditoTributario')}
                </Option>
                <Option value="PISCOFINSSTSobreCigarros">
                  {formatModulo('PISCOFINSSTSobreCigarros')}
                </Option>
                <Option value="INSSPessoaFisica">{formatModulo('INSSPessoaFisica')}</Option>
                <Option value="SubvencoesICMS">{formatModulo('SubvencoesICMS')}</Option>
                <Option value="RevisorPISCOFINS">{formatModulo('RevisorPISCOFINS')}</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xl={2} md={12} sm={8} span={24}>
            <Form.Item label="Tipo" name="tipo">
              <Select onChange={(e) => handleChange(e, 'tipo')}>
                <Option value="">Todos</Option>
                <Option value="proposta">Proposta</Option>
                <Option value="contrato">Contrato</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xl={2} md={12} sm={8} span={24}>
            <Form.Item label="Chance" name="chance">
              <Select onChange={(e) => handleChange(e, 'chance')}>
                <Option value="">Todas</Option>
                <Option value="alta">Alta</Option>
                <Option value="media">Média</Option>
                <Option value="baixa">Baixa</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xl={3} md={12} sm={8} span={24}>
            <Form.Item label="Status" name="status">
              <Select onChange={(e) => handleChange(e, 'status')}>
                <Option value="">Todos</Option>
                <Option value="andamento">Em andamento</Option>
                <Option value="aceito">Aceito</Option>
                <Option value="recusado">Recusado</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

Filtro.defaultProps = {
  filtro: {
    page: 1,
    pageSize: 20,
    modulo: '',
    tipo: '',
    chance: '',
    status: '',
  },
};

Filtro.propTypes = {
  setFiltro: PropTypes.func.isRequired,
  filtro: PropTypes.shape({
    page: PropTypes.number,
    pageSize: PropTypes.number,
    modulo: PropTypes.string,
    tipo: PropTypes.string,
    chance: PropTypes.string,
    status: PropTypes.string,
  }),
};

export default Filtro;
